import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useMemo, useState } from "react";
import { actions as ConnectionActions } from "../../../Ducks/Connection.duck";
import { actions as LogEntriesActions } from "../../../Ducks/LogEntries.duck";
import { actions as TasksActions } from "../../../Ducks/Tasks.duck";
import { actions as ModulesActions } from "../../../Ducks/Modules.duck";
import { actions as ActivityLogsActions } from "../../../Ducks/ActivityLogs.duck";
import { actions as DownloadsActions } from "../../../Ducks/Downloads.duck";
import { downloadMissingDetails, uploadOcrCsv } from "../../../Services";
import Grid from "@mui/material/Grid";
import { CardContent, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";
import { ConnectionNoteInput } from "../../../Components/ConnectionNoteInput";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import TasksTable from "../../../Components/TasksTable";
import LogsTable from "../../../Components/LogsTable/LogsTable";
import ActivityLogsTable from "../../../Components/ActivityLogsTable";
import { Formik } from "formik";
import * as Yup from "yup";
import FormikModal from "app/components/FormikModal";
import ConnectionRunForm from "../../../Components/Forms/ConnectionRunForm";
import UploadFileDialog from "../../../Components/UploadFileDialog";
import OcrCsvUploadDialog from "../../../Components/OcrCsvUploadDialog";
import UploadDropdown from "../../../Components/UploadDropdown";
import { ConfirmDialog, ConfirmDialogWithTextInput, FileType } from "app/components";
import { isLocalEnvironment } from "../../../../../utils";
import { MESSAGE_SEVERITY_ERROR, MESSAGE_SEVERITY_SUCCESS } from "../../../../../common";
import { actions as AppActions } from "../../../../App/Ducks/App.duck";
import { HasAccessTo, IsOwnerAdmin, IsSuperAdmin } from "app/components/Authorization";
import { CONNECTION } from "../../../../../common/Authorization/entities";
import { CLEAR, DOWNLOAD, NOTE, RUN, UPDATE } from "../../../../../common/Authorization/permissions";
import EmployerConnectionWizard from "../../../../Employers/Components/EmployerConnectionWizard";
import { selectors } from "../../../../Employers/Ducks/Employer.duck";
import { ButtonStyled, TooltipStyled } from "./ConnectionInfoTab.styles";
import { ConnectionSourcePackageTypeEnum, requiresSynchronizeInsurerData } from "../../../../../types";
const MODAL_PURGE_CONNECTION_TESTID = "modal-purge-connection";
const BTN_CHANGE_CONNECTION_TESTID = "btn-change-connection";
const BTN_RUN_CONNECTION_TESTID = "btn-run-connection";
const BTN_PURGE_CONNECTION_TESTID = "btn-purge-connection";
const BTN_SYNCHRONIZE_INSURER_DATA_TESTID = "btn-synchronize-insurer-data";
const BTN_UPLOAD_TESTID = "btn-upload";
const BTN_CLEAR_TASKS_TESTID = "btn-clear-tasks";
const BTN_FORCE_CLEAR_TASKS_TESTID = "btn-force-clear-tasks";
const BTN_CLEAR_OLD_LOGS_TESTID = "btn-clear-old-logs";
const BTN_CLEAR_LOGS_TESTID = "btn-clear-logs";
const BTN_DOWNLOAD_LOGS_TESTID = "btn-download-logs";
const ConnectionInfoTab = ({ intl }) => {
  const dispatch = useDispatch();
  const { connectionId } = useParams();
  const [modalOpen, setModalOpen] = useState(false);
  const [modal2Open, setModal2Open] = useState(false);
  const [modalUploadOpen, setModalUploadOpen] = useState(false);
  const [modalOcrCsvOpen, setModalOcrCsvOpen] = useState(false);
  const [confirmPurgeOpen, setConfirmPurgeOpen] = useState(false);
  const {
    item: connection,
    connectionAccess,
    purgingConnection,
    uploadingFile,
    runIsLocked
  } = useSelector((state) => state.ConnectionReducer);
  const {
    page: pageLogs,
    pageSize: pageSizeLogs,
    loading: loadingLogs,
    items: logs,
    totalCount: totalCountLogs,
    canDownload,
    checkingDownload,
    clearingLogs
  } = useSelector((state) => state.LogEntriesReducer);
  const {
    page,
    pageSize,
    loading: loadingTasks,
    items: tasks,
    totalCount,
    clearingTasks
  } = useSelector((state) => state.TasksReducer);
  const {
    page: pageActivityLogs,
    pageSize: pageSizeActivityLogs,
    loading: loadingActivityLogs,
    items: ActivityLogs,
    totalCount: totalCountActivityLogs
  } = useSelector((state) => state.ActivityLogsReducer);
  const { loading: loadingModules, items: modules } = useSelector((state) => state.ModulesReducer);
  const { item: employer, loading: employerLoading } = useSelector(
    (state) => selectors.selectEmployer(state.EmployerReducer)
  );
  useEffect(() => {
    if (connectionAccess) {
      dispatch(LogEntriesActions.setConnectionId(connectionId));
      dispatch(LogEntriesActions.requestData(connectionId));
      dispatch(LogEntriesActions.checkCanDownloadMissingDetails());
      dispatch(TasksActions.setConnectionId(connectionId));
      dispatch(TasksActions.requestData(connectionId));
      dispatch(ModulesActions.requestData(connectionId));
      dispatch(ActivityLogsActions.setConnectionId(connectionId));
      dispatch(ActivityLogsActions.requestData(connectionId));
      dispatch(DownloadsActions.setConnectionId(connectionId));
    }
  }, [connectionAccess, connectionId, dispatch]);
  const clearTasks = async (force) => {
    dispatch(TasksActions.clearTasks(connectionId, force));
  };
  const clearLogs = async (old) => {
    dispatch(LogEntriesActions.clearLogs(connectionId, old));
  };
  const handlePageChange = (event, newPage) => {
    dispatch(TasksActions.changePage(newPage + 1));
  };
  const handleRowsPerPageChange = (event) => {
    dispatch(TasksActions.setPageSize(event.target.value));
  };
  const handlePageChangeLogs = (event, newPage) => {
    dispatch(LogEntriesActions.changePage(newPage + 1));
  };
  const handleRowsPerPageChangeLogs = (event) => {
    dispatch(LogEntriesActions.setPageSize(event.target.value));
  };
  const handlePageChangeActivityLogs = (event, newPage) => {
    dispatch(ActivityLogsActions.changePage(newPage + 1));
  };
  const handleRowsPerPageChangeActivityLogs = (event) => {
    dispatch(ActivityLogsActions.setPageSize(event.target.value));
  };
  const handleClickChange = () => {
    setModal2Open(true);
  };
  const handleRunConnectionModule = async (conn) => {
    const payload = {
      connectionId: conn,
      parameters: {}
    };
    try {
      dispatch(ConnectionActions.forceRun(payload));
    } catch (error) {
      const severity = MESSAGE_SEVERITY_ERROR;
      const details = {
        method: "handleRunConnectionModule",
        message: error,
        severity
      };
      dispatch(AppActions.displayMessage(details));
    }
    dispatch(ConnectionActions.requestData(connectionId));
  };
  const handleSynchronizeInsurerData = async (conn) => {
    const payload = {
      connectionId: conn,
      parameters: {}
    };
    try {
      dispatch(ConnectionActions.synchronizeInsurerData(payload));
    } catch (error) {
      const severity = MESSAGE_SEVERITY_ERROR;
      const details = {
        method: "handleSynchronizeInsurerData",
        message: error,
        severity
      };
      dispatch(AppActions.displayMessage(details));
    }
    dispatch(ConnectionActions.requestData(connectionId));
  };
  const handlePurgeConnectionModule = async () => {
    dispatch(ConnectionActions.purgeConnection({ connectionId }));
    dispatch(ConnectionActions.requestData(connectionId));
  };
  const toBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
  const handleUploadFile = async (files) => {
    const payload = {
      connectionId,
      parameters: {
        fileName: files[0].name
      },
      base64FileContent: await toBase64(files[0])
    };
    try {
      dispatch(ConnectionActions.uploadFromFile(payload));
    } catch (error) {
      const severity = MESSAGE_SEVERITY_ERROR;
      const details = {
        method: "handleRunConnectionModule",
        message: error,
        severity
      };
      dispatch(AppActions.displayMessage(details));
    }
  };
  const handleChangeConnection = async () => {
    setModal2Open(false);
    dispatch(ConnectionActions.requestData(connectionId));
  };
  const downloadLogs = async () => {
    try {
      const response = await downloadMissingDetails(connectionId);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", response.headers["x-filename"]);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      const details = {
        method: "downloadLogs",
        message: error,
        MESSAGE_SEVERITY_ERROR
      };
      dispatch(AppActions.displayMessage(details));
    }
  };
  const hasFileUploadPackage = useMemo(() => {
    return connection?.packages.some((e) => e.packageType === "file-upload" || e.packageType === "ocr") || false;
  }, [connection]);
  const hasOCRPackage = useMemo(() => {
    return connection?.packages.some((e) => e.packageType === "ocr") || false;
  }, [connection]);
  const acceptedFileTypes = useMemo(() => {
    return connection?.packages.some((e) => e.packageType === "ocr") ? [FileType.PDF] : [FileType.Csv, FileType.Xml];
  }, [connection]);
  const disabledIfNoAccessToConnectionUpdate = !HasAccessTo(CONNECTION, UPDATE);
  const disabledIfNoAccessToConnectionRun = !HasAccessTo(CONNECTION, RUN);
  const disabledIfNoAccessToConnectionClear = !HasAccessTo(CONNECTION, CLEAR);
  const disabledIfNoAccessToConnectionDownload = !HasAccessTo(CONNECTION, DOWNLOAD);
  const enabledIfAccessToConnectionNote = HasAccessTo(CONNECTION, NOTE);
  const disabledIfNotAnOwnerOrSuperAdmin = !(IsSuperAdmin() || IsOwnerAdmin());
  const handleUploadOcrCsv = async (files) => {
    const file = files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = async () => {
      const base64File = reader.result;
      try {
        await uploadOcrCsv({
          connectionId,
          base64File,
          fileName: file.name
        });
        dispatch(
          AppActions.displayMessage({
            method: "uploadOcrCsv",
            severity: MESSAGE_SEVERITY_SUCCESS
          })
        );
      } catch (error) {
        dispatch(
          AppActions.displayMessage({
            method: "uploadOcrCsv",
            message: error?.response?.data?.message || error.message,
            severity: MESSAGE_SEVERITY_ERROR
          })
        );
      }
    };
  };
  const uploadDropdownOptions = useMemo(() => {
    return [
      {
        key: "upload",
        title: /* @__PURE__ */ React.createElement(FormattedMessage, { id: "button.upload.ocr" }),
        action: () => setModalUploadOpen(true),
        disabled: disabledIfNoAccessToConnectionRun || uploadingFile
      },
      {
        key: "ocr-csv",
        title: /* @__PURE__ */ React.createElement(FormattedMessage, { id: "button.ocr_csv" }),
        action: () => setModalOcrCsvOpen(true),
        disabled: disabledIfNoAccessToConnectionRun || uploadingFile
      }
    ];
  }, [disabledIfNoAccessToConnectionRun, uploadingFile]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Grid, { container: true, spacing: 5 }, /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 12 }, /* @__PURE__ */ React.createElement(
    ButtonStyled,
    {
      variant: "contained",
      onClick: () => handleClickChange(connection),
      disabled: disabledIfNoAccessToConnectionUpdate || employerLoading,
      "data-testid": BTN_CHANGE_CONNECTION_TESTID
    },
    /* @__PURE__ */ React.createElement(FormattedMessage, { id: "button.change" })
  ), /* @__PURE__ */ React.createElement(
    ButtonStyled,
    {
      variant: "contained",
      disabled: disabledIfNoAccessToConnectionRun || purgingConnection || runIsLocked,
      onClick: () => handleRunConnectionModule(connectionId),
      "data-testid": BTN_RUN_CONNECTION_TESTID
    },
    /* @__PURE__ */ React.createElement(FormattedMessage, { id: "button.run" })
  ), /* @__PURE__ */ React.createElement(
    ButtonStyled,
    {
      variant: "contained",
      disabled: disabledIfNotAnOwnerOrSuperAdmin || purgingConnection,
      onClick: () => setConfirmPurgeOpen(true),
      "data-testid": BTN_PURGE_CONNECTION_TESTID
    },
    /* @__PURE__ */ React.createElement(FormattedMessage, { id: purgingConnection ? "button.purging" : "button.purge" })
  ), connection?.connectionType === ConnectionSourcePackageTypeEnum.Manual && requiresSynchronizeInsurerData(connection?.product?.credential?.packageType) && /* @__PURE__ */ React.createElement(
    ButtonStyled,
    {
      variant: "contained",
      disabled: disabledIfNoAccessToConnectionRun || purgingConnection || runIsLocked,
      onClick: () => handleSynchronizeInsurerData(connectionId),
      "data-testid": BTN_SYNCHRONIZE_INSURER_DATA_TESTID
    },
    /* @__PURE__ */ React.createElement(FormattedMessage, { id: "button.synchronizeInsurerData" })
  ), hasFileUploadPackage && !hasOCRPackage && /* @__PURE__ */ React.createElement(
    ButtonStyled,
    {
      variant: "outlined",
      disabled: disabledIfNoAccessToConnectionRun || uploadingFile,
      onClick: () => setModalUploadOpen(true),
      "data-testid": BTN_UPLOAD_TESTID
    },
    /* @__PURE__ */ React.createElement(FormattedMessage, { id: "button.upload" })
  ), hasOCRPackage && /* @__PURE__ */ React.createElement(
    UploadDropdown,
    {
      options: uploadDropdownOptions,
      disabled: disabledIfNoAccessToConnectionRun || uploadingFile
    }
  )), /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 6 }, /* @__PURE__ */ React.createElement(Card, null, /* @__PURE__ */ React.createElement(
    CardHeader,
    {
      title: /* @__PURE__ */ React.createElement(FormattedMessage, { id: "connections.tasks.title" }),
      action: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
        ButtonStyled,
        {
          margin: "left",
          variant: "outlined",
          onClick: () => clearTasks(false),
          disabled: disabledIfNoAccessToConnectionClear || clearingTasks,
          "data-testid": BTN_CLEAR_TASKS_TESTID
        },
        /* @__PURE__ */ React.createElement(FormattedMessage, { id: "connectionDetails.clearTasks" })
      ), /* @__PURE__ */ React.createElement(
        ButtonStyled,
        {
          margin: "left",
          variant: "outlined",
          onClick: () => clearTasks(true),
          disabled: disabledIfNoAccessToConnectionClear || clearingTasks,
          "data-testid": BTN_FORCE_CLEAR_TASKS_TESTID
        },
        /* @__PURE__ */ React.createElement(FormattedMessage, { id: "connectionDetails.forceClearTasks" })
      ))
    }
  ), /* @__PURE__ */ React.createElement(CardContent, null, /* @__PURE__ */ React.createElement(
    TasksTable,
    {
      tasks,
      modules,
      loading: loadingTasks || loadingModules,
      paging: true,
      page: page - 1,
      rowsPerPage: pageSize,
      totalCount,
      handlePageChange,
      handleRowsPerPageChange
    }
  )))), /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 6 }, /* @__PURE__ */ React.createElement(Card, null, /* @__PURE__ */ React.createElement(
    CardHeader,
    {
      title: /* @__PURE__ */ React.createElement(FormattedMessage, { id: "connections.logs.title" }),
      action: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
        ButtonStyled,
        {
          margin: "left",
          variant: "outlined",
          onClick: () => clearLogs(true),
          disabled: disabledIfNoAccessToConnectionClear || clearingLogs,
          "data-testid": BTN_CLEAR_OLD_LOGS_TESTID
        },
        /* @__PURE__ */ React.createElement(FormattedMessage, { id: "connectionDetails.clearOldLogs" })
      ), /* @__PURE__ */ React.createElement(
        ButtonStyled,
        {
          margin: "left",
          variant: "outlined",
          onClick: () => clearLogs(false),
          disabled: disabledIfNoAccessToConnectionClear || clearingLogs,
          "data-testid": BTN_CLEAR_LOGS_TESTID
        },
        /* @__PURE__ */ React.createElement(FormattedMessage, { id: "connectionDetails.clearLogs" })
      ), /* @__PURE__ */ React.createElement(
        TooltipStyled,
        {
          disableHoverListener: checkingDownload || canDownload,
          variant: "outlined",
          title: /* @__PURE__ */ React.createElement(FormattedMessage, { id: "connectionDetails.logEntries.noMissingDetails" })
        },
        /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(
          ButtonStyled,
          {
            margin: "left",
            variant: "outlined",
            onClick: () => downloadLogs(),
            disabled: disabledIfNoAccessToConnectionDownload || !canDownload,
            "data-testid": BTN_DOWNLOAD_LOGS_TESTID
          },
          /* @__PURE__ */ React.createElement(FormattedMessage, { id: "connectionDetails.logEntries.download" })
        ))
      ))
    }
  ), /* @__PURE__ */ React.createElement(CardContent, null, /* @__PURE__ */ React.createElement(
    LogsTable,
    {
      logs,
      loading: loadingLogs,
      paging: true,
      page: pageLogs - 1,
      rowsPerPage: pageSizeLogs,
      totalCount: totalCountLogs,
      handlePageChange: handlePageChangeLogs,
      handleRowsPerPageChange: handleRowsPerPageChangeLogs
    }
  )))), enabledIfAccessToConnectionNote && /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 6 }, /* @__PURE__ */ React.createElement(ConnectionNoteInput, { connectionId })), /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 6 }, /* @__PURE__ */ React.createElement(Card, null, /* @__PURE__ */ React.createElement(CardHeader, { title: /* @__PURE__ */ React.createElement(FormattedMessage, { id: "connections.activityLogs.title" }) }), /* @__PURE__ */ React.createElement(CardContent, null, /* @__PURE__ */ React.createElement(
    ActivityLogsTable,
    {
      tasks: ActivityLogs,
      modules,
      loading: loadingActivityLogs,
      paging: true,
      page: pageActivityLogs - 1,
      rowsPerPage: pageSizeActivityLogs,
      totalCount: totalCountActivityLogs,
      handlePageChange: handlePageChangeActivityLogs,
      handleRowsPerPageChange: handleRowsPerPageChangeActivityLogs
    }
  ))))), /* @__PURE__ */ React.createElement(
    Formik,
    {
      validationSchema: Yup.object().shape({
        date: Yup.date().required()
      }),
      enableReinitialize: true,
      initialValues: {
        date: /* @__PURE__ */ new Date(),
        tenants: []
      },
      onSubmit: handleRunConnectionModule
    },
    /* @__PURE__ */ React.createElement(
      FormikModal,
      {
        show: modalOpen,
        onHide: () => setModalOpen(false),
        title: /* @__PURE__ */ React.createElement(FormattedMessage, { id: "connections.run" })
      },
      /* @__PURE__ */ React.createElement(ConnectionRunForm, null)
    )
  ), modal2Open && /* @__PURE__ */ React.createElement(
    EmployerConnectionWizard,
    {
      onClose: () => setModal2Open(false),
      onUpserted: handleChangeConnection,
      connectionId,
      employer
    }
  ), modalUploadOpen && hasFileUploadPackage && /* @__PURE__ */ React.createElement(
    UploadFileDialog,
    {
      types: acceptedFileTypes,
      onClose: () => setModalUploadOpen(false),
      open: modalUploadOpen,
      setOpen: setModalUploadOpen,
      onConfirm: handleUploadFile,
      connectionId,
      isOCR: hasOCRPackage
    }
  ), modalOcrCsvOpen && hasOCRPackage && /* @__PURE__ */ React.createElement(
    OcrCsvUploadDialog,
    {
      open: modalOcrCsvOpen,
      setOpen: setModalOcrCsvOpen,
      onConfirm: handleUploadOcrCsv,
      connectionId
    }
  ), isLocalEnvironment() && /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      title: intl.formatMessage({ id: "button.purge" }),
      testId: MODAL_PURGE_CONNECTION_TESTID,
      open: confirmPurgeOpen,
      setOpen: setConfirmPurgeOpen,
      onConfirm: handlePurgeConnectionModule
    },
    /* @__PURE__ */ React.createElement(FormattedMessage, { id: "connections.confirmPurgeConnection" })
  ), !isLocalEnvironment() && /* @__PURE__ */ React.createElement(
    ConfirmDialogWithTextInput,
    {
      title: intl.formatMessage({ id: "button.purge" }),
      testId: MODAL_PURGE_CONNECTION_TESTID,
      label: intl.formatMessage({ id: "connections.confirmPurgeConnection.withRiddle.helper" }),
      errorMessage: intl.formatMessage({ id: "connections.confirmPurgeConnection.withRiddle.helper.wrong" }),
      solution: connection?.connectionName,
      open: confirmPurgeOpen,
      setOpen: setConfirmPurgeOpen,
      onConfirm: handlePurgeConnectionModule
    },
    /* @__PURE__ */ React.createElement(Typography, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "connections.confirmPurgeConnection" })),
    /* @__PURE__ */ React.createElement("br", null),
    /* @__PURE__ */ React.createElement(Typography, null, /* @__PURE__ */ React.createElement(
      FormattedMessage,
      {
        id: "connections.confirmPurgeConnection.withRiddle",
        values: { connectionName: connection?.connectionName, b: (chunks) => /* @__PURE__ */ React.createElement("b", null, chunks) }
      }
    ))
  ));
};
export default injectIntl(ConnectionInfoTab);
